// components/AOSInit.tsx
'use client';

import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function AOSInit(): null {
    useEffect(() => {
        AOS.init({
            duration: 300,
            easing: 'ease-in-out',
        });
    }, []);

    return null;
}